import { render, staticRenderFns } from "./AddModifyServiceProvider.vue?vue&type=template&id=649f9fea&scoped=true"
import script from "./AddModifyServiceProvider.vue?vue&type=script&lang=js"
export * from "./AddModifyServiceProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f9fea",
  null
  
)

export default component.exports